export default class eventMessage {
    constructor($state, $filter, $rootScope, $timeout, SweetAlert, Event, Campaign, Events) {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/event-message.html'),
            scope: {
                event: '=',
                message: '=',
                messageType: '=',
                isAlone: '=',
                first: '=',
                sortSchedules: '&'
            },
            controller: EventMessageCtrl,
            controllerAs: 'msg'
        }
    }
};

class EventMessageCtrl {
    constructor($scope, $state, $filter, $timeout, Event, Events, Campaign, SweetAlert) {
        this._scope = $scope;
        this._state = $state;
        this._timeout = $timeout;
        this._translator = $filter('translate');
        this._filter = $filter;

        this.eventRepo = Event;
        this.eventHandler = Events;
        this.campaignRepo = Campaign;
        this.alerter = SweetAlert;

        this.dispatcherTypeMap = {
            1: 'invitation',
            2: 'confirmation',
            3: 'rsvp-reminder',
            4: 'attendance-reminder',
            5: 'post',
            6: 'cancellation'
        };

        this._scope.$on('event:updateSchedule', () => {
            if (this._scope.event && this._scope.message) {
                this.eventMessageType = this.dispatcherTypeMap[this._scope.message.pivot.event_dispatcher_type_id];

                if (this._scope.message.campaign_status_id == 4) {
                    this.campaignRepo.getSchedule(
                        this._scope.message.id,
                        'scheduled',
                        this._scope.message.message_type_id
                    ).then((schedule) => {
                        this._scope.message['schedule'] = schedule;
                        this._timeout(() => {
                            this._scope.sortSchedules();
                        });
                    });
                }
            }
        });

        this._scope.$on('event:schedule:updated', () => {
            this.campaignRepo.getSchedule(
                this._scope.message.id,
                'scheduled',
                this._scope.message.message_type_id
            ).then((schedule) => {
                this._scope.message['schedule'] = schedule;

                this._timeout(() => {
                    this._scope.sortSchedules();
                });
            });
        });
    }

    editMessage() {
        if (this._scope.messageType == 'campaign') {
            this._state.go('event.editCampaign', {
                eventId: this._scope.event.id,
                type: 'campaign',
                dispatcherId: this._scope.message.id
            });
        } else if (this._scope.messageType == 'automation') {
            this._state.go('event.editAutomation', {
                eventId: this._scope.event.id,
                type: 'automation',
                dispatcherId: this._scope.message.automation_id,
                emailId: this._scope.message.id
            });
        }
    };

    deleteMessage() {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:DELETE'),
            text: this._translator('EVENT:MESSAGE:DELETE_BODY'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            if (isConfirm) {
                let messageId = this._scope.messageType == 'automation' ? this._scope.message.automation_id : this._scope.message.id;
                this.eventRepo.removeDispatcher(this._scope.event.id, this._scope.messageType, messageId).then(() => {
                    this._scope.$emit('event:dispatcher:removed', {
                        dispatcherId: this._scope.message.id,
                        dispatcherType: this._scope.messageType
                    });
                }, (error) => {
                    this.eventHandler.flashEvent('error', this._translator('GLOBAL:FLASH:DELETE_ERROR'));
                });
            }
        });
    };

    toStatistics() {
        let stateName = this._scope.messageType == 'campaign' ? 'event.campaignStatistics' : 'event.automationStatistics';

        this._state.go(stateName, {
            id: this._scope.message.id,
            type: this._scope.messageType,
            eventId: this._scope.event.id,
            folder: 'open'
        });
    };

    scheduleToSpoken() {
        return this._filter('date')(this._scope.message.schedule.date, 'longDate') + ' ' + this._scope.message.schedule.time.hour + ":" + this._scope.message.schedule.time.minutes;
    };

    showSchedule() {
        let eventPage = this._scope.event.pages.episubscription ? this._scope.event.pages.episubscription : this._scope.event.pages.subscription;

        if (eventPage && eventPage.published) {
            this._scope.$broadcast('event:message:showSchedule', {
                event: this._scope.event,
                message: this._scope.message,
                eventMessageType: this.eventMessageType
            });
        } else {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:PUBLISH_BEFORE_SCHEDULE_HEADER'),
                text: this._translator('EVENT:FLASH:PUBLISH_BEFORE_SCHEDULE_BODY'),
                type: 'error'
            });
        }
    };

    addDispatcher(type) {
        this.eventRepo.addDispatcher(this._scope.event.id, type).then((event) => {
            this._scope.event = event.data;
            this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:UPDATED'));
            this._scope.$emit('event:dispatcher:added', this._scope.event);
        }, (error) => {
            // Do nothing.
        });
    };
}
